// ═══════════════════════════════════════════════════════════════
// API: Historial de Salarios
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const salaryHistoryAPI = {
  // Historial completo de un empleado
  getByEmployee: async (employeeId) => {
    const response = await api.get(`/salary-history?employee_id=${employeeId}`);
    return response.data;
  },

  // Salario vigente en una fecha puntual (un empleado)
  getAtDate: async (employeeId, date) => {
    const response = await api.get(
      `/salary-history/at-date?employee_id=${employeeId}&date=${date}`
    );
    return response.data;
  },

  // Salario vigente de TODOS los empleados de la empresa en una fecha
  // Devuelve { employee_id: salario_mensual }
  getBulkAtDate: async (companyId, date) => {
    const response = await api.get(
      `/salary-history/bulk-at-date?companyId=${companyId}&date=${date}`
    );
    return response.data?.data || {};
  },
};
